export default [
	{
		industry_id: 1,
		children: false,
		link: "http://www.espa.or.jp/internship/example/2019test_questions.pdf",
		title: '2019年介護技能実習評価試験'
	},
	{
		industry_id: 1,
		children: false,
		link: "http://www.espa.or.jp/internship/example/2018test_questions.pdf",
		title: '2018年介護技能実習評価試験'
	},
	{
		industry_id: 2,
		children: false,
		link: "https://www.j-bma.or.jp/wp-content/uploads/2020/01/2019_2020%E5%AE%9F%E6%8A%80%E8%A9%A6%E9%A8%93%E5%95%8F%E9%A1%8C_%E6%97%A5%E6%9C%AC%E8%AA%9E.pdf",
		title: '2019-2020年ビルクリーニング業過去問題'
	},
	{
		industry_id: 2,
		children: false,
		link: "https://www.j-bma.or.jp/wp-content/uploads/2019/12/2019tokutei_mondai_v2.pdf",
		title: '2019年判断試験(問題)'
	},
	{
		industry_id: 2,
		children: false,
		link: "https://www.j-bma.or.jp/wp-content/uploads/2019/12/2019tokutei_kaitou.pdf",
		title: '2019年判断試験(解答)'
	},
	{
		industry_id: 10,
		children: false,
		link: "https://caipt.or.jp/download/20190414_kakomon.pdf",
		title: '2019年介護技能実習評価試験'
	},
	{
		industry_id: 11,
		children: true,
		title: '2020年農業技能実習評価試験初級',
		item: [
			{
				link: 'https://www.nca.or.jp/upload/hatasaku2020.pdf',
				title: '試験問題(田畑・野菜)'
			},
			{
				link: 'https://www.nca.or.jp/upload/shisetsu2020.pdf',
				title: '試験問題(施設園芸)'
			},
			{
				link: 'https://www.nca.or.jp/upload/kinoko2020.pdf',
				title: '試験問題(きのこ)'
			},
			{
				link: 'https://www.nca.or.jp/upload/kaju2020.pdf',
				title: '試験問題(果樹)'
			},
			{
				link: 'https://www.nca.or.jp/upload/rakunou2020.pdf',
				title: '試験問題(酪農)'
			},
			{
				link: 'https://www.nca.or.jp/upload/youkei2020.pdf',
				title: '試験問題(養鶏)'
			},
			{
				link: 'https://www.nca.or.jp/upload/youton2020.pdf',
				title: '試験問題(養豚)'
			},
		]
	},
	{
		industry_id: 11,
		children: true,
		title: '農業技能実習評価試験専門級(試験問題一部)',
		item: [
			{
				link: 'https://www.nca.or.jp/upload/3e179aeb5049d63e2bec29f141e94baed96b1a09.pdf',
				title: '試験問題(田畑・野菜)'
			},
			{
				link: 'https://www.nca.or.jp/upload/0276126299b9592fca1ee3ad0e1ebbfb93b2e9f5.pdf',
				title: '試験問題(施設園芸)'
			},
			{
				link: 'https://www.nca.or.jp/upload/dc60379d669be6a8353157d64e62ead4b411525c.pdf',
				title: '試験問題(きのこ)'
			},
			{
				link: 'https://www.nca.or.jp/upload/e7925771416cbe50ceb8a563b78d408444e0c241.pdf',
				title: '試験問題(果樹)'
			},
			{
				link: 'https://www.nca.or.jp/upload/f490603922b47c581d0c6f6f0c38f73a21144e47.pdf',
				title: '試験問題(酪農)'
			},
			{
				link: 'https://www.nca.or.jp/upload/ce47d9af1e4bbc20872a039c8be6c43fdca65ee7.pdf',
				title: '試験問題(養鶏)'
			},
			{
				link: 'https://www.nca.or.jp/upload/48ebb23eb365cc10f68d73603686e310c6be9174.pdf',
				title: '試験問題(養豚)'
			},
		]
	},
	{
		industry_id: 11,
		children: true,
		title: '農業技能実習評価試験上級(試験問題一部)',
		item: [
			{
				link: 'https://www.nca.or.jp/upload/4584bc63e2234deacb56fb213191edc82313aec2.pdf',
				title: '試験問題(田畑・野菜)'
			},
			{
				link: 'https://www.nca.or.jp/upload/58e41ab4888b1ecd7582d15fabca331502351704.pdf',
				title: '試験問題(施設園芸)'
			},
			{
				link: 'https://www.nca.or.jp/upload/abae4fae1080cfcd5186f9e1d79bf0b90b8316a2.pdf',
				title: '試験問題(きのこ)'
			},
			{
				link: 'https://www.nca.or.jp/upload/3f20b6f89e1c54a9eb2f1a4c3f5da2ca87b63e34.pdf',
				title: '試験問題(常葉果樹)'
			},
			{
				link: 'https://www.nca.or.jp/upload/be4fa83206b0d14d71d401b71185a29c6907f21a.pdf',
				title: '試験問題(落葉果樹)'
			},
			{
				link: 'https://www.nca.or.jp/upload/9b97e8e404bb4d03183ce62ecc0c4159eeba756f.pdf',
				title: '試験問題(酪農)'
			},
			{
				link: 'https://www.nca.or.jp/upload/e08d7bf5acf055f084c082aeeb1809dcfd49a257.pdf',
				title: '試験問題(養鶏)'
			},
			{
				link: 'https://www.nca.or.jp/upload/e940d451a14023ed471a5637c9926c387670422c.pdf',
				title: '試験問題(養豚)'
			},
		]
	}
 ]